import { useEffect } from 'react';

// Requests images in the background so they're in the browser cache before they're shown.
// Brandfolder resizes each image on its first request, which can take several seconds, so warming
// them early hides that wait when the user moves through a carousel.
export const usePreloadImages = (urls: string[]) => {
    const urlsKey = urls.join('|');

    useEffect(() => {
        urls.forEach((url) => {
            const image = new Image();
            image.decoding = 'async';
            image.src = url;
        });
        // urlsKey changes whenever the urls do, without re-running for a new array of the same urls
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlsKey]);
};
